// extracted by mini-css-extract-plugin
export var brandColor = "#846d3d";
export var mainColor = "#2f4758";
export var subColor = "#c0d1dd";
export var lightColor = "#f4f6f8";
export var greyColor = "#707070";
export var darkColor = "#363636";
export var subscriptionColor = "#65c79b";
export var orderColor = "#298df3";
export var errorColor = "#fd3894";
export var frontlineColor = "#e08912";
export var categoryFoodColor = "#e08912";
export var categoryDogHealthColor = "#298df3";
export var categoryTrainingColor = "#65c79b";
export var categoryLifestyleColor = "#fd3188";
export var post_wrapper = "post-module--post_wrapper--20B8Z";
export var post_header = "post-module--post_header--2Iw6Q";
export var hero_img_wrapper = "post-module--hero_img_wrapper--2-g4L";
export var hero_img = "post-module--hero_img--2adCr";
export var background_amp_hero = "post-module--background_amp_hero--2uY93";
export var hero_img_caption = "post-module--hero_img_caption--kfpyS";
export var post_content = "post-module--post_content--18PQ-";
export var main_content = "post-module--main_content--2PCyz";
export var author_card = "post-module--author_card--qYlEu";
export var main_content_post_banner = "post-module--main_content_post_banner--22spG";
export var side_bar_post_banner = "post-module--side_bar_post_banner--2CPfT";